export default {
    usePopups: false,
};
